export default "<p>\n  Angelo Maria Sodini (1875 - 1939) scrittore e importante critico letterario\n</p>\n";